module.exports = __webpack_public_path__ + "img/investors_main_bg.2c66b013.jpg";